import { motion } from "framer-motion";
import {
    Fingerprint,
    PenTool,
    Share2,
    Megaphone,
    MonitorSmartphone,
    Camera,
    ArrowUpRight,
} from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const SERVICES = [
    {
        num: "01",
        name: "Branding",
        desc: "Build a brand people recognize.",
        icon: Fingerprint,
        bg: "bg-[#141414]",
        accent: "text-[#D3A0A7]",
    },
    {
        num: "02",
        name: "Graphic Design",
        desc: "Make every piece of your business look intentional.",
        icon: PenTool,
        bg: "bg-[#EAF1F7]",
        accent: "text-[#7FA8C9]",
    },
    {
        num: "03",
        name: "Social Media",
        desc: "Give people a reason to stop scrolling.",
        icon: Share2,
        bg: "bg-[#F1F1EF]",
        accent: "text-[#D3A0A7]",
    },
    {
        num: "04",
        name: "Marketing",
        desc: "Turn attention into opportunity.",
        icon: Megaphone,
        bg: "bg-[#EAF1F7]",
        accent: "text-[#7FA8C9]",
    },
    {
        num: "05",
        name: "Web Design",
        desc: "Give your business a digital home worth visiting.",
        icon: MonitorSmartphone,
        bg: "bg-[#141414]",
        accent: "text-[#D3A0A7]",
    },
    {
        num: "06",
        name: "Content",
        desc: "Give your brand something to say.",
        icon: Camera,
        bg: "bg-[#F1F1EF]",
        accent: "text-[#7FA8C9]",
    },
];

export const Services = () => (
    <section
        id="services"
        data-testid="services-section"
        className="py-20 md:py-32 px-5 sm:px-8 lg:px-12 bg-[#0C0C0C] border border-[#262626] rounded-[2.5rem] mx-3 md:mx-6 my-6"
    >
        <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl mb-14 md:mb-20">
                <Reveal>
                    <Eyebrow>Creative solutions</Eyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-4 font-serif-ed text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-[#F1F1EF]">
                        for real businesses.
                    </h2>
                </Reveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
                {SERVICES.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.07}>
                        <motion.a
                            href="#contact"
                            data-testid={`service-card-${s.num}`}
                            whileHover={{ y: -8 }}
                            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                            className={`group relative block ${s.bg} rounded-3xl p-8 md:p-9 border border-[#0C0C0C]/5 overflow-hidden h-full`}
                        >
                            <div className="flex items-start justify-between">
                                <span className="font-serif-ed italic text-lg text-[#A9A6A0]">
                                    {s.num}
                                </span>
                                <s.icon
                                    size={26}
                                    strokeWidth={1.6}
                                    className={`${s.accent} transition-transform duration-500 group-hover:rotate-6 group-hover:scale-110`}
                                />
                            </div>
                            <h3 className="mt-16 md:mt-20 font-serif-ed text-2xl md:text-[1.7rem] tracking-tight text-[#0C0C0C]">
                                {s.name}
                            </h3>
                            <p className="mt-2 text-sm md:text-base leading-relaxed text-[#A9A6A0]">
                                {s.desc}
                            </p>
                            <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0C0C0C]">
                                Explore {s.name.split(" ")[0]}
                                <ArrowUpRight
                                    size={15}
                                    className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                />
                            </span>
                        </motion.a>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
